import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { pendingChangesModal } from "../../guard/pending-changes.guard";

@Component({
    selector: "love-it-modal-buttons",
    templateUrl: "./modal-buttons.component.html",
    styleUrls: ["./modal-buttons.component.scss"],
    standalone: false
})
export class ModalButtonsComponent implements OnInit {
  @Output() onSubmit = new EventEmitter<boolean>();
  @Input() dirty: boolean = false;
  @Input() speichernText: string;
  @Input() speichernSchliessenText: string;
  @Input() showSpeichernUndSchliessenOnly: boolean = false;
  @Input() showSpeichernButton: boolean = true;

  constructor(public modal: NgbActiveModal) {}

  ngOnInit(): void {}

  async closeModal() {
    if (!this.dirty) {
      this.modal.dismiss();
      return;
    }
    const confirm = await pendingChangesModal();
    if (confirm.isConfirmed) {
      this.modal.dismiss();
    }
  }
}
